import { useStudioStore } from '@/store/studio-store'

type StudioStoreSnapshot = ReturnType<typeof useStudioStore.getState>

interface ShortcutSpec {
  key: string
  action: (store: StudioStoreSnapshot) => void
  description: string
}

function toggleInspectorOverlay(store: StudioStoreSnapshot): void {
  if (store.inspectorOverlayOpen) {
    store.closeInspector()
    return
  }
  store.openAboxPropertiesPanel()
}

function shortcuts(): ShortcutSpec[] {
  return [
    { key: 'k',  action: (store) => store.toggleChatSidebar(),    description: 'Toggle intent loop' },
    { key: '\\', action: toggleInspectorOverlay,                  description: 'Toggle inspector overlay' },
    { key: 'j',  action: (store) => store.toggleDevtoolsDock(),    description: 'Toggle devtools dock' },
    { key: ',',  action: (store) => store.toggleBottomBar(),       description: 'Toggle bottom bar' },
  ]
}

let listener: ((e: KeyboardEvent) => void) | null = null
const listenerOptions = { capture: true } as const

export function registerShortcuts(): void {
  if (listener) return // idempotent
  listener = (e: KeyboardEvent) => {
    // Require ⌘ (metaKey on Mac) or Ctrl on Windows/Linux
    if (!e.metaKey && !e.ctrlKey) return
    const match = shortcuts().find((s) => s.key.toLowerCase() === e.key.toLowerCase())
    if (!match) return
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation?.()
    match.action(useStudioStore.getState())
  }
  window.addEventListener('keydown', listener, listenerOptions)
}

export function unregisterShortcuts(): void {
  if (!listener) return
  window.removeEventListener('keydown', listener, listenerOptions)
  listener = null
}
